import React from "react";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export const Section = ({ title, desc, children }) => (
  <div className="rounded-xl border bg-card p-5 sm:p-6">
    <div className="mb-5">
      <h3 className="font-display text-base font-semibold">{title}</h3>
      {desc && <p className="text-xs text-muted-foreground">{desc}</p>}
    </div>
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">{children}</div>
  </div>
);

export const Field = ({ label, hint, children, full }) => (
  <div className={`space-y-1.5 ${full ? "lg:col-span-2" : ""}`}>
    <Label>{label}</Label>
    {children}
    {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
  </div>
);

export const SelectField = ({ value, onChange, options, testid, placeholder }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testid}><SelectValue placeholder={placeholder || "Select"} /></SelectTrigger>
    <SelectContent>
      {options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}
    </SelectContent>
  </Select>
);
